import { ProductID } from '../../../../lib/ProductID';
import { ProductOrderType } from './index';

const ProductOrderTitles = {
  [ProductID.MembershipWithRoadsideAssistance]: 'NAF-medlemskap',
  [ProductID.Membership]: 'NAF-medlemskap',
  [ProductID.Young]: 'Ung-medlemskap',
  [ProductID.MC]: 'MC-medlemskap',
  [ProductID.MCWithRoadsideAssistance]: 'MC-medlemskap',
  [ProductID.RoadSideAssistance]: 'Veihjelp',
  [ProductID.ChargingTag]: 'Ladebrikke',
  [ProductID.Idp1Year]: 'Internasjonalt førerkort: 1-år',
  [ProductID.Idp3Year]: 'Internasjonalt førerkort: 3-år',
  [ProductID.Idp1and3Year]: 'Internasjonalt førerkort: 1-år og 3-år',
  [ProductID.TrialMembership]: 'Prøvemedlemskap',
  [ProductID.TrialMembershipWithRoadsideAssistance]: 'Prøvemedlemskap',
};

export const getProductOrderTitle = ({ productId }: ProductOrderType) => ProductOrderTitles[productId];
